import React from "react";
import logoAm from "./assets/logo_am.svg";   // keep your existing import

export default function Footer() {
    const year = new Date().getFullYear();    // ← gets the current year

    return (
        <footer
            className="text-[1.125rem] relative pl-8 mt-[3.75rem] md:mt-[2rem] flex flex-wrap w-full h-[16rem] md:h-[7rem] mx-auto max-w-[101.25rem] bg-[20px_top] md:bg-left-top bg-no-repeat"
            style={{ backgroundImage: `url(${logoAm})` }}
        >
            <div className="ml-14 md:ml-8 mt-2 mr-20 whitespace-nowrap">
                © {year} Autonomous Machines       {/* ← dynamic */}
            </div>

            <div className="transform -translate-x-4 md:translate-x-0 md:ml-20 md:mt-2 m-auto underline underline-offset-2  md:pr-8 whitespace-nowrap ">
                <a href="mailto:contact@autonomous-machines.com">
                    contact@autonomous-machines.com
                </a>
            </div>
        </footer>
    );
}
